import type { ApiKeyScope, IssueApiKeyRequest } from "@developerz.ai/ggcoin-sdk";

/** Scopes offered in the onboarding key form, in display order. */
export const SCOPES: readonly ApiKeyScope[] = [
  "wallet:read",
  "wallet:write",
  "transaction:write",
  "agent:provision",
];

/**
 * Least privilege: the quickstart only reads a balance, so a freshly issued
 * key defaults to read-only. Users opt into write scopes explicitly.
 */
export function defaultScopes(): Set<ApiKeyScope> {
  return new Set<ApiKeyScope>(["wallet:read"]);
}

/** Toggle one scope, returning a new set (never mutates the input). */
export function toggleScope(
  current: ReadonlySet<ApiKeyScope>,
  scope: ApiKeyScope,
): Set<ApiKeyScope> {
  const next = new Set(current);
  if (next.has(scope)) {
    next.delete(scope);
  } else {
    next.add(scope);
  }
  return next;
}

/** A key can only be issued with a label and at least one scope. */
export function canIssue(label: string, scopes: ReadonlySet<ApiKeyScope>): boolean {
  return label.trim().length > 0 && scopes.size > 0;
}

/** Build the issue-key request body from the current form state. */
export function buildIssueRequest(
  label: string,
  scopes: ReadonlySet<ApiKeyScope>,
): IssueApiKeyRequest {
  return { label, scopes: [...scopes] };
}
